class GuideTailles {
    constructor() {
        this.guideTaillesContainer = document.querySelector("#guide-tailles");
        this.categoryName = document.querySelectorAll('.category-name');
        this.productName = document.querySelectorAll('.product-name');
        this.modelSections = document.querySelectorAll('.models-section');
        this.selectedCategoryId = 0;
        this.selectedProductId = 0;
        this.events();
    }

    events() {
        this.categoryNameClicked();
        this.productNameClicked();
        this.displayProductsOfSelectedCategory();
    }

    /**
     * Category name clicked
     * @since 1.0.0
     */
    categoryNameClicked() {
        this.setContainerDataAttribute(this.categoryName, 'data-selected-category-index');
    }

    /**
     * Product name clicked
     * @since 1.0.0
     */
    productNameClicked() {
        this.setContainerDataAttribute(this.productName, 'data-selected-product-index');
    }

    /**
     * Dom element clicked
     * @since 1.0.0
     */
    setContainerDataAttribute(domElement, attributeSet) {
        if (domElement && this.guideTaillesContainer) {
            domElement.forEach(element => {
                element.addEventListener("click", (e) => {
                    e.preventDefault();
                    element.classList.contains('category-name') ? this.selectedCategoryId = element.getAttribute('data-key') : this.selectedProductId = element.getAttribute('data-key');
                    this.guideTaillesContainer.setAttribute(attributeSet, element.getAttribute('data-key'));
                    this.applyStylesToSelectedItems(element);
                })
            });
        }
    }

    /**
     * Apply styles for categories
     * @since 1.0.0
     */
    applyStylesToSelectedItems(clickedElement) {
        const selectedElementKey = clickedElement.getAttribute('data-key');

        if (this.categoryName && clickedElement.classList.contains('category-name')) {
            this.selectedCategoryId = selectedElementKey;
            this.categoryName.forEach((element, i) => {
                selectedElementKey == i ? element.classList.remove('opacity-30') : element.classList.add('opacity-30');
            });
            this.displayProductsOfSelectedCategory();
            this.selectedProductId = 0;
        }

        if (this.productName && clickedElement.classList.contains('product-name')) {
            this.selectedProductId = selectedElementKey;
            this.productName.forEach((element, i) => {
                selectedElementKey == i || this.selectedProductId == 0 ? element.classList.remove('opacity-30') : element.classList.add('opacity-30');
            });
        }
    }

    /**
     * Apply styles for products
     * @since 1.0.0
     */
    applySelectedProductStyles() {

    }

    /**
     * Display products based on selected category
     * @since 1.0.0
     */
    displayProductsOfSelectedCategory() {
        if (this.guideTaillesContainer) {
            if (this.guideTaillesContainer.getAttribute('data-selected-category-index') && this.modelSections.length > 0) {
                let selectedCategoryIndex = this.guideTaillesContainer.getAttribute('data-selected-category-index');
                (this.modelSections).forEach(element => {
                    let categoryId = element.getAttribute('data-category-id')
                    if (categoryId != selectedCategoryIndex) {
                        element.classList.add('hidden');
                    } else {
                        element.classList.remove('hidden');
                    }
                });
            }
        }
    }
}

export default GuideTailles;